import React from "react";

export default function ColorFrame15({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <path
          d="M208.236 145.321C208.236 185.004 176.941 216.925 138.639 216.925C100.338 216.925 69.0421 185.004 69.0421 145.321C69.0421 105.638 100.338 73.718 138.639 73.718C176.941 73.718 208.236 105.638 208.236 145.321Z"
          fill="white"
          stroke="#FF5130"
          strokeWidth="11"
        />
        <path
          d="M84.3757 198.972C84.5487 196.845 86.9026 195.646 88.7248 196.757L117.037 214.02C118.577 214.959 118.877 217.07 117.66 218.401L106.447 230.671C105.548 231.654 104.091 231.889 102.929 231.237L84.2796 220.78C83.3022 220.232 82.7338 219.164 82.8246 218.047L84.3757 198.972Z"
          fill="#FF5130"
        />
        <path
          d="M148.871 219.845C148.049 218.339 148.726 216.452 150.319 215.812L181.448 203.303C183.468 202.491 185.62 204.139 185.363 206.301L182.717 228.587C182.566 229.856 181.594 230.871 180.333 231.078L159.085 234.553C157.884 234.75 156.689 234.166 156.106 233.098L148.871 219.845Z"
          fill="#FF5130"
        />
        <path
          d="M41.1905 120.216C40.7236 118.754 41.5101 117.197 42.9569 116.685L78.2262 104.197C80.5517 103.374 82.7619 105.678 81.8427 107.967L70.3791 136.519C69.8648 137.8 68.4987 138.627 67.1186 138.603C65.566 138.577 63.0582 138.591 59.0691 138.729C50.179 139.035 47.7266 135.075 46.1939 133.348C45.0811 132.095 42.5136 124.36 41.1905 120.216Z"
          fill="#FF5130"
        />
        <path
          d="M226.061 142.974C225.313 143.135 224.544 142.966 223.915 142.531L206.632 130.55C206.24 130.278 205.922 129.912 205.706 129.486L191.121 100.592C189.892 98.1576 192.413 95.5571 194.869 96.7421C205.61 101.925 225.094 111.51 234.374 117.232C247.565 125.365 242.816 130.8 241.539 135.576C240.477 139.549 229.667 142.196 226.061 142.974Z"
          fill="#FF5130"
        />
        <path
          d="M45.887 101.805C47.1482 100.716 49.0686 100.928 50.0616 102.266L66.7112 124.698C67.8954 126.293 67.1365 128.581 65.2334 129.152L49.1366 133.982C47.7145 134.409 46.202 133.679 45.6511 132.3L37.4092 111.676C36.9554 110.54 37.2721 109.242 38.1979 108.442L45.887 101.805Z"
          fill="#FF5130"
        />
        <path
          d="M206.627 134.873C206.522 133.612 207.256 132.432 208.432 131.968L235.874 121.157C236.208 121.026 236.563 120.955 236.919 121.01C238.481 121.249 242.992 122.592 244.406 130.13C246.125 139.302 241.826 145.895 235.233 147.984C230.002 149.642 215.748 148.669 210.084 148.196C208.706 148.081 207.634 146.984 207.519 145.606L206.627 134.873Z"
          fill="#FF5130"
        />
        <path
          d="M108.636 227.396C108.041 225.445 86.175 214.112 82.4488 216.406C78.7226 218.699 82.4488 222.323 82.4488 225.445C82.4488 229.348 80.0173 234.339 76.744 236.569C73.4706 238.8 73.5742 227.396 65.262 231.024C60.695 233.017 58.4413 239.218 59.9292 241.448C61.4171 243.678 78.4348 250.216 80.0173 250.509C81.5999 250.801 85.0394 248.795 85.6713 249.081C86.3032 249.368 85.6713 252.739 85.6713 252.739C87.1592 253.575 90.5516 255.638 92.218 254.969C93.8845 254.3 98.2688 245.212 100.253 241.03C101.245 237.684 102.803 233.418 105.66 232.972C108.517 232.526 109.231 229.348 108.636 227.396Z"
          fill="black"
        />
        <rect
          x="82.391"
          y="228.255"
          width="7.02068"
          height="6.87912"
          rx="1.43315"
          transform="rotate(33.835 82.391 228.255)"
          stroke="#FFC444"
          strokeWidth="1.71978"
        />
        <rect
          x="87.2729"
          y="234.831"
          width="1.71978"
          height="3.92655"
          rx="0.85989"
          transform="rotate(122.123 87.2729 234.831)"
          fill="#FFC444"
        />
        <path
          d="M181.609 226.785C179.521 226.176 156.112 229.036 153.967 232.213C151.822 235.39 156.66 237.657 158.979 239.828C158.979 239.828 163.832 243.494 162.684 249.044C162.303 250.882 161.389 251.162 160.294 253.093C157.957 257.217 159.123 261.543 160.668 261.887C165.123 262.881 183.783 262.701 185.933 261.887C188.083 261.074 185.858 252.594 184.674 251.244C181.245 247.335 180.816 248.543 180.041 244.595C179.432 241.493 180.257 234.814 182.353 232.822C184.449 230.831 183.697 227.394 181.609 226.785Z"
          fill="black"
        />
        <rect
          x="-0.728107"
          y="0.974002"
          width="7.02068"
          height="6.87912"
          rx="1.43315"
          transform="matrix(-0.989725 0.142981 0.142981 0.989725 173.611 239.826)"
          stroke="#FFC444"
          strokeWidth="1.71978"
        />
        <rect
          width="1.71978"
          height="3.92655"
          rx="0.85989"
          transform="matrix(0.113344 0.993556 0.993556 -0.113344 167.226 244.505)"
          fill="#FFC444"
        />
        <path
          d="M46.5149 97.8194C46.843 101.725 50.2625 104.846 49.7271 106.767C46.4078 108.155 40.9256 114.582 40.4116 112.532C39.7692 109.97 39.448 106.767 36.8782 106.767C34.3084 106.767 29.2728 105.186 28.5264 102.604C27.8839 100.382 27.5627 95.5775 29.1688 91.7343C30.7778 87.8842 37.8419 91.414 39.1267 92.3748C39.3409 92.1613 38.4201 89.2361 40.7329 86.9302C43.0457 84.6242 44.9088 86.9302 43.6239 89.8126C42.339 92.695 46.1937 93.9958 46.5149 97.8194Z"
          fill="#F74C2B"
        />
        <path
          d="M211.156 135.576C212.933 138.222 211.747 139.353 212.093 140.945C210.121 143.314 211.689 148.297 210.498 147.05C209.009 145.492 203.415 146.754 200.836 146.181C198.667 145.699 196.252 143.028 195.392 139.589C194.933 137.755 190.091 138.155 189.946 136.436C189.659 133.023 199.486 134.279 200.836 134.429C200.914 134.188 198.523 133.111 198.258 132.423C197.304 129.943 200.376 130.069 203.418 130.703C206.459 131.337 209.417 132.985 211.156 135.576Z"
          fill="#F64C2B"
        />
        <path
          d="M34.4754 113.019C33.1994 111.135 33.4202 108.796 35.4524 107.773C37.8058 106.588 41.9819 105.087 44.6246 102.614C45.7932 101.52 46.7369 100.661 47.4984 99.9858C49.372 98.3257 51.4738 98.7572 52.8777 100.83L53.261 101.396C55.3866 104.533 54.5661 108.8 51.4283 110.926L44.5149 115.609C41.3785 117.734 37.1137 116.913 34.989 113.777L34.4754 113.019Z"
          fill="#E5F0FF"
        />
        <path
          d="M211.334 151.674C208.862 151.59 206.925 149.518 207.008 147.045C207.028 146.474 207.157 145.916 207.34 145.375C207.936 143.625 209.108 139.225 208.004 134.143C207.922 133.769 207.849 133.423 207.783 133.103C207.24 130.461 209.259 129.519 211.955 129.61L212.967 129.644C216.595 129.767 219.437 132.808 219.315 136.436L218.966 146.754C218.87 149.61 216.476 151.847 213.62 151.751L211.334 151.674Z"
          fill="#E5F0FF"
        />
        <path
          d="M163.863 60.4788C160.725 74.2138 149.199 82.6771 133.613 79.1163C118.026 75.5556 109.689 71.9439 115.422 49.0136C116.855 32.1024 129.388 25.8168 144.975 29.3776C160.562 32.9383 171.315 40.1281 163.863 60.4788Z"
          fill="#FFCBBD"
        />
        <path
          d="M111.982 73.0907C111.982 65.6383 114.121 45.999 115.5 44.5C117.763 44.7866 114.562 55.3197 114.879 58.5633C115.196 61.8069 115.773 62.6448 116.569 63.9185C118.002 66.2115 123.053 68.9463 127.747 70.511C134.626 72.8041 144.085 69.6511 150.104 67.9313C153.564 66.9428 155.97 69.0026 158.99 67.0715C161.224 65.6431 164.707 52.4293 165.869 51.5C167.302 50.3535 166.325 60.7924 166.301 64.4918C166.284 67.2043 166.111 70.379 165.869 72.8041C165.461 76.8876 162.864 92.5942 153.544 93.4414C140.932 94.5879 141.505 98.6008 138.352 101.467C135.83 103.76 118.002 95.1611 113.702 85.1291C112.597 82.5495 111.983 81.9947 111.982 73.0907Z"
          fill="#E5F0FF"
        />
        <path
          d="M134.745 77.9323C131.93 77.6105 129.467 74.8354 129.467 74.393C129.467 74.1319 131.966 75.3217 135.097 75.2778C137.27 75.2473 140.294 73.9506 140.727 73.9506C141.782 73.9506 138.616 78.3747 134.745 77.9323Z"
          fill="white"
        />
        <path
          d="M134.209 65.9066L134.241 65.9169C135.1 65.4285 138.132 64.0004 141.514 65.3308C145.238 66.7958 145.063 68.8193 147.529 70.9313C150.454 73.4358 157.094 71.4562 156.982 72.1033C155.836 74.1543 151.253 77.9633 144.378 77.9633C136.932 77.9633 135.353 72.3206 134.639 72.4629C134.639 72.4629 133.207 74.9495 131.489 76.3099C129.77 77.6703 126.905 77.9633 124.9 77.4049C119.642 75.9403 115.939 71.0993 116.307 71.2243C117.851 71.7493 120.317 71.8103 122.036 70.9313C123.472 70.1969 123.685 69.9771 125.187 67.9678C128.153 64.0004 131.727 65.1256 134.209 65.9066Z"
          fill="#D5E6FF"
        />
        <path
          d="M134.035 65.332L134.068 65.3423C134.927 64.8545 137.959 63.4281 141.34 64.7569C145.064 66.2202 145.064 68.8541 147.53 70.9637C150.454 73.4652 156.52 71.488 156.409 72.1343C154.977 73.6952 150.394 76.8168 143.52 76.8168C134.927 76.8168 135.214 69.7931 134.068 72.1343C132.922 74.4756 130.456 76.8168 125.301 76.4632C119.864 76.0902 116.515 71.4241 116.883 71.549C118.427 72.0733 120.63 71.7953 121.864 70.9637C123.204 70.0603 123.512 69.3978 125.014 67.3908C127.98 63.4281 131.554 64.5519 134.035 65.332Z"
          fill="#E5F0FF"
        />
        <ellipse
          cx="134.626"
          cy="64.2051"
          rx="3.43956"
          ry="2.29304"
          fill="#FFAA93"
        />
        <circle cx="146.091" cy="59.619" r="1.14652" fill="black" />
        <circle cx="127.174" cy="59.0458" r="1.14652" fill="black" />
        <circle cx="175" cy="11" r="7" fill="#E5F0FF" />
        <path
          d="M115.123 36.3308C114.212 28.8862 116.147 21.2076 121.906 16.4027C125.95 13.0285 131.241 9.54197 137.206 7.89568C148.958 4.65242 161.5 6.00005 167.847 8.37861C174.195 10.7572 170.319 10.4 166.661 14.1187C164.874 15.9356 164.438 17.6859 164.461 19.0009C164.488 20.5733 165.288 22.0158 165.879 23.4734C166.364 24.6707 167.034 26.2894 167.847 28.1561C168.726 30.1733 170.167 36.5933 170.168 41.0544C170.169 42.385 170.039 43.5386 169.857 44.5009C169.445 46.6765 167.329 47.8153 165.123 47.6298L120.644 43.8904C117.939 43.6629 115.764 41.5688 115.434 38.874L115.123 36.3308Z"
          fill="#FF5130"
        />
        <path
          d="M107.189 34.2485C107.561 28.7645 112.208 24.8089 117.631 25.7023C117.918 25.7496 118.213 25.7985 118.514 25.8493C126.517 27.194 140.065 27.1862 149.5 28.4999C158.145 29.7036 160.997 31.9711 166.014 32.2864C167.904 32.4051 169.483 32.5312 170.801 32.6581C175.024 33.0646 177.073 36.3066 176.503 40.5106L176.255 42.3422C175.395 48.6897 169.552 53.138 163.205 52.2778C163.205 52.2778 150.196 49.5567 141.205 49.2964C132.213 49.0361 115.705 45.8407 115.705 45.8407C111.036 47.0228 106.574 43.3006 106.9 38.4954L107.189 34.2485Z"
          fill="#E5F0FF"
        />
        <path
          d="M146.378 55.6062C147.142 55.4151 148.958 55.3769 150.104 56.7527"
          stroke="#E5F0FF"
          strokeWidth="1.71978"
          strokeLinecap="round"
        />
        <path
          d="M128.034 54.5567C127.269 54.3656 125.454 54.3274 124.308 55.7032"
          stroke="#E5F0FF"
          strokeWidth="1.71978"
          strokeLinecap="round"
        />
        {children}
      </g>
    </svg>
  );
}
